/**
 * Get whether the string contains a given substring.
 * @param value The substring to find.
 * @param options The search options.
 */
String.prototype.contains = function(this: string, value: string, options?: { ignoreCase: boolean, ignoreDiacritics: boolean }) {
    if (!value)
        return value === "";

    let str = this;
    let substr = value;

    if (options?.ignoreCase) {
        str = str.toLowerCase();
        substr = value.toLowerCase();
    }

    if (options?.ignoreDiacritics) {
        const helper = sessionStore.helper;
        str = helper.RemoveDiacritics(str);
        substr = helper.RemoveDiacritics(substr);
    }

    return str.indexOf(substr) > -1;
};

String.prototype.startsWith = function(value: string) {
    if (!value)
        return false;

    const self: string = this;
    if (value.length > self.length)
        return false;

    return self.substring(0, value.length) == value;
};

String.prototype.endsWith = function(value: string) {
    if (!value)
        return false;

    const self: string = this;
    if (value.length > self.length)
        return false;

    return self.substring(self.length - value.length, self.length) == value;
};

String.prototype.truncate = function(maxLenght: number) {
    return limitTextLength(this, maxLenght);
};

String.prototype.padLeft = function(char: string, length: number) {
    if (this == null)
        return null;
    if (char == null || char.length != 1) {
        console.log("invalid Padding char : " + char);
        return this; // invalid Padding char
    }

    let tmpString = this;

    while (tmpString.length < length) {
        tmpString = char + tmpString;
    }

    return tmpString;
};

String.prototype.padRight = function(char: string, length: number) {
    if (this == null)
        return null;
    if (char == null || char.length != 1) {
        console.log("invalid Padding char : " + char);
        return this; // invalid Padding char
    }

    let tmpString = this;

    while (tmpString.length < length) {
        tmpString = tmpString + char;
    }

    return tmpString;
};

String.prototype.hashCode = function() {
    let hash = 0, i, chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

String.prototype.toTitleCase = function() {
    return this.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};

// toString is required because some things call this when it's actually a number type.
String.prototype.isNullOrWhiteSpace = function(value: string) {
    return !value || !value.toString().trim().length;
};

/**
 * Replace all occurences of a literal substring.
 * @param this The string to modify.
 * @param search The substring to replace.
 * @param replacement The value to substitute.
 * @param caseSensitive Whether the search should be case-insensitive. Default false.
 * @returns Returns the new string.
 */
String.prototype.replaceAll = function(this: string, search: string, replacement: string, caseInsensitive?: boolean): string {
    if (search == null || replacement == null)
        return this;

    // escape regex syntax (from https://stackoverflow.com/a/7313467/262123)
    search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    return this.replace(new RegExp(search, "g" + (caseInsensitive ? "i" : "")), replacement);
};

String.prototype.removeMarkdown = function() {
    let output = this || "";

    // Remove horizontal rules (stripListHeaders conflict with this rule, which is why it has been moved to the top)
    output = output.replace(/^(-\s*?|\*\s*?|_\s*?){3,}\s*$/gm, "");

    try {
        output = output
            // Remove HTML tags
            .replace(/<[^>]*>/g, "")
            // Remove setext-style headers
            .replace(/^[=\-]{2,}\s*$/g, "")
            // Remove footnotes?
            .replace(/\[\^.+?\](\: .*?$)?/g, "")
            .replace(/\s{0,2}\[.*?\]: .*?$/g, "")
            // Remove images
            .replace(/\!\[(.*?)\][\[\(].*?[\]\)]/g, "")
            // Remove inline links
            .replace(/\[(.*?)\][\[\(].*?[\]\)]/g, "$1")
            // Remove blockquotes
            .replace(/^\s{0,3}>\s?/g, "")
            .replace(/(^|\n)\s{0,3}>\s?/g, "\n\n")
            // Remove reference-style links?
            .replace(/^\s{1,2}\[(.*?)\]: (\S+)( ".*?")?\s*$/g, "")
            // Remove atx-style headers
            .replace(
                /^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} {0,}(\n)?\s{0,}$/gm,
                "$1$2$3"
            )
            // Remove emphasis (repeat the line to remove double emphasis)
            .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, "$2")
            .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, "$2")
            // Remove code blocks
            .replace(/(`{3,})(.*?)\1/gm, "$2")
            // Remove inline code
            .replace(/`(.+?)`/g, "$1")
            // Replace two or more newlines with exactly two
            .replace(/\n{2,}/g, "\n\n");
    }
    catch (e) {
        console.error(e);

        return this;
    }
    return output;
};

String.prototype.isNumber = function(): boolean {
    return !isNaN(this);
};
